import React from 'react';
import {
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import RawText from '../component/RawText';
import CustomMap from '../component/Map';
import Calendar from '../component/Calendar';
import TableInput from '../component/Table/TableInput';
import Freetext from '../component/Freetext';
import ListInput from '../component/ListInput';
import NumberInput from '../component/NumberInput';
import UploadMedia from '../component/UploadMedia';
import VideoEmbed from '../component/VideoEmbed';
import SingleSelect from '../component/SingleSelect';
import Singlechoice from '../component/Singlechoice';
import Multiplechoice from '../component/Multiplechoice';
import SingleLinetext from '../component/SingleLinetext';
import ESignature from '../component/ESignature';
import ImageAnnotation from '../component/ImageAnnotation';
import Address from '../component/Address';
import FilePreview from '../component/FilePreview';
import RichTextEditor from '../component/RichTextEditor';
import RepeatableSectionsInput from '../component/Table/RepeatableSectionsInput';
import DisplayDatabaseContent from '../component/DatabaseContent/DisplayDatabaseContent';
import { parsePlaceholder } from '../utils/detectAnswer';

class ComponentRenderer {
  constructor(formComponent) {
    this.form = formComponent;
  }

  componentSelector = (format, data, section, key) => {
    data = parsePlaceholder(data, this.form.props.form);

    switch (format) {
      case 'checkbox':  // v2
      case 'multiple_choice':
        return data.drop_down == 'true' ? (
          <Accordion>
            <AccordionSummary key={data.key} expandIcon={<ExpandMoreIcon />}>
              <Typography>{data.key}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              {' '}
              <Multiplechoice
                key={data.key}
                getDataFromComponent={this.form.getDataFromComponent.bind(
                  this.form
                )}
                data={data}
              />
            </AccordionDetails>
          </Accordion>
        ) : (
          <Multiplechoice
            key={data.key}
            getDataFromComponent={this.form.getDataFromComponent.bind(
              this.form
            )}
            data={data}
          />
        );
      case 'long_text':  // v2
      case 'free_text':
        return (
          <Freetext
            key={data.key}
            getDataFromComponent={this.form.getDataFromComponent.bind(
              this.form
            )}
            data={data}
          />
        );
      case 'short_text':  // v2
      case 'single_line_text':
        return (
          <SingleLinetext
            key={data.key}
            getDataFromComponent={this.form.getDataFromComponent.bind(
              this.form
            )}
            data={data}
          />
        );
      case 'signature':  // v2
      case 'e_signature':
        return (
          <ESignature
            key={data.key}
            getDataFromComponent={this.form.getDataFromComponent.bind(
              this.form
            )}
            data={data}
          />
        );
      case 'image_annotation':
        return (
          <ImageAnnotation
            key={data.key}
            getDataFromComponent={this.form.getDataFromComponent.bind(
              this.form
            )}
            data={data}
          />
        );
      case 'address':
        return (
          <Address
            key={data.key}
            getDataFromComponent={this.form.getDataFromComponent.bind(this.form)}
            data={data}
          />
        );
      case 'radio_button':  // v2
      case 'single_choice':
        return data.drop_down == 'true' ? (
          <Accordion>
            <AccordionSummary key={data.key} expandIcon={<ExpandMoreIcon />}>
              <Typography>{data.key}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Singlechoice
                key={data.key}
                getDataFromComponent={this.form.getDataFromComponent.bind(
                  this.form
                )}
                data={data}
              />
            </AccordionDetails>
          </Accordion>
        ) : (
          <Singlechoice
            key={data.key}
            getDataFromComponent={this.form.getDataFromComponent.bind(
              this.form
            )}
            data={data}
          />
        );
      case 'number':  // v2
      case 'number_input':
        return (
          <NumberInput
            key={data.key}
            getDataFromComponent={this.form.getDataFromComponent.bind(
              this.form
            )}
            data={data}
          />
        );
      case 'map':  // v2
      case 'custom_map':
        return (
          <CustomMap
            key={data.key}
            getDataFromComponent={this.form.getDataFromComponent.bind(
              this.form
            )}
            data={data}
          />
        );
      case 'date':  // v2
      case 'calendar':
        return (
          <Calendar
            key={data.key}
            getDataFromComponent={this.form.getDataFromComponent.bind(
              this.form
            )}
            data={data}
          />
        );
      case 'content_block':  // v2 schema name
      case 'row_text':
        if (section == 'title') {
          return (
            <div>
              <h2>{data.data}</h2>
            </div>
          );
        } else if (section == 'answer') {
          return (
            <RawText
              data={data}
            />
          );
        } else return <div id={`${key}-question-title`}>{data.data}</div>;

      case 'dropdown':  // v2
      case 'single_select':
        return (
          <SingleSelect
            key={data.key}
            getDataFromComponent={this.form.getDataFromComponent.bind(
              this.form
            )}
            data={data}
          />
        );
      case 'upload_file':  // v2 schema name
      case 'file_upload':  // v2 frontend alias
      case 'upload_media':
        return (
          <UploadMedia
            key={data.key}
            getDataFromComponent={this.form.getDataFromComponent.bind(
              this.form
            )}
            data={data}
          />
        );
      case 'list':  // v2
      case 'list_input':
        return (
          <ListInput
            key={data.key}
            getDataFromComponent={this.form.getDataFromComponent.bind(
              this.form
            )}
            data={data}
          />
        );
      case 'table':
        return (
          <TableInput
            key={data.key}
            getDataFromComponent={this.form.getDataFromComponent.bind(
              this.form
            )}
            data={data}
            tableErrors={this.form.state.required_list_table}
            setRequiredTableErrors={(updatedErrors) =>
              this.form.setState({ required_list_table: updatedErrors })
            }
          />
        );
      case 'repeatable_section':
        return (
          <RepeatableSectionsInput
            key={data.key}
            getDataFromComponent={this.form.getDataFromComponent.bind(
              this.form
            )}
            data={data}
            tableErrors={this.form.state.required_list_table}
            setRequiredTableErrors={(updatedErrors) =>
              this.form.setState({ required_list_table: updatedErrors })
            }
          />
        );
      case 'display_database_content':
        return (
          <DisplayDatabaseContent
            data={data}
            getDataFromComponent={this.form.getDataFromComponent.bind(
              this.form
            )}
          />
        );
      case 'file_preview':
        return (
          <FilePreview
            key={data.key}
            getDataFromComponent={this.form.getDataFromComponent.bind(
              this.form
            )}
            data={data}
          />
        );
      case 'embed_video':  // v2 schema name
      case 'video_embed':
        return (
          <VideoEmbed
            key={data.key}
            getDataFromComponent={this.form.getDataFromComponent.bind(
              this.form
            )}
            data={data}
          />
        );
      case 'rich_text':  // v2
      case 'rich_text_editor':
        return (
          <RichTextEditor
            key={data.key}
            getDataFromComponent={this.form.getDataFromComponent.bind(
              this.form
            )}
            data={data}
          />
        );
      default:
        return section == 'title' ? (
          <div className="componentSelectorTitle">
            <h3 id={`form-title-${key}`} className="form-title">
              {data.data}
            </h3>
          </div>
        ) : (
          <div style={{ textAlign: 'left' }}>
            <p>{data.data}</p>
          </div>
        );
    }
  };
}

export default ComponentRenderer;
